import { useCallback, useEffect, useState } from "react";

export function useAsync<T>(loader: (signal: AbortSignal) => Promise<T>, dependencies: readonly unknown[] = []) {
  const [data, setData] = useState<T>();
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState(true);
  const [nonce, setNonce] = useState(0);
  const retry = useCallback(() => setNonce((value) => value + 1), []);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError(undefined);
    loader(controller.signal).then((value) => { if (!controller.signal.aborted) setData(value); }).catch((reason) => { if (!controller.signal.aborted) setError(reason instanceof Error ? reason : new Error(String(reason))); }).finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
    // loader must be stable or derived only from dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, nonce]);
  return { data, error, loading, retry };
}
